import { render, staticRenderFns } from "./CurrentBranch.vue?vue&type=template&id=5317a06c&scoped=true&"
import script from "./CurrentBranch.vue?vue&type=script&lang=js&"
export * from "./CurrentBranch.vue?vue&type=script&lang=js&"
import style0 from "./CurrentBranch.vue?vue&type=style&index=0&id=5317a06c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317a06c",
  null
  
)

export default component.exports